/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findActiveTicketAuctionCatalogParts } from '../fn/ticker-auction-catalog-part/find-active-ticket-auction-catalog-parts';
import { FindActiveTicketAuctionCatalogParts$Params } from '../fn/ticker-auction-catalog-part/find-active-ticket-auction-catalog-parts';
import { getTicketAuctionCatalogPart } from '../fn/ticker-auction-catalog-part/get-ticket-auction-catalog-part';
import { GetTicketAuctionCatalogPart$Params } from '../fn/ticker-auction-catalog-part/get-ticket-auction-catalog-part';
import { TickerAuctionCatalogPartDto } from '../models/ticker-auction-catalog-part-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedTickerAuctionCatalogPartService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findActiveTicketAuctionCatalogParts()` */
  static readonly FindActiveTicketAuctionCatalogPartsPath = '/api/ticker/auction-catalog-parts/active';

  /**
   * Finds all active parts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findActiveTicketAuctionCatalogParts()` instead.
   *
   * This method doesn't expect any request body.
   */
  findActiveTicketAuctionCatalogParts$Response(params?: FindActiveTicketAuctionCatalogParts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TickerAuctionCatalogPartDto>>> {
    return findActiveTicketAuctionCatalogParts(this.http, this.rootUrl, params, context);
  }

  /**
   * Finds all active parts.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findActiveTicketAuctionCatalogParts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findActiveTicketAuctionCatalogParts(params?: FindActiveTicketAuctionCatalogParts$Params, context?: HttpContext): Observable<Array<TickerAuctionCatalogPartDto>> {
    return this.findActiveTicketAuctionCatalogParts$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TickerAuctionCatalogPartDto>>): Array<TickerAuctionCatalogPartDto> => r.body)
    );
  }

  /** Path part for operation `getTicketAuctionCatalogPart()` */
  static readonly GetTicketAuctionCatalogPartPath = '/api/ticker/auction-catalog-parts/{id}';

  /**
   * Gets a auction catalog part by its id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTicketAuctionCatalogPart()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTicketAuctionCatalogPart$Response(params: GetTicketAuctionCatalogPart$Params, context?: HttpContext): Observable<StrictHttpResponse<TickerAuctionCatalogPartDto>> {
    return getTicketAuctionCatalogPart(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a auction catalog part by its id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTicketAuctionCatalogPart$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTicketAuctionCatalogPart(params: GetTicketAuctionCatalogPart$Params, context?: HttpContext): Observable<TickerAuctionCatalogPartDto> {
    return this.getTicketAuctionCatalogPart$Response(params, context).pipe(
      map((r: StrictHttpResponse<TickerAuctionCatalogPartDto>): TickerAuctionCatalogPartDto => r.body)
    );
  }

}
